module.exports = __webpack_public_path__ + "img/recruiting_assistant.88e3873.svg";